// extracted by mini-css-extract-plugin
export default {"reasonsWrapper":"gftl5vzAqq1jLa1eJerj","reason":"mXbjcYOdaXQK5bFAeYmR"};